import React from 'react';
import FalconCardHeader from 'components/common/FalconCardHeader';
import PropTypes from 'prop-types';
const NewBusinessAnalysisTableHeader = ({ title }) => {
  return (
    <div>
      <FalconCardHeader
        title=""
        light
        titleTag="h6"
        startEl={
          <div id="orders-actions" className="d-flex flex-column gap-2">
            <div>
              <h4>{title}</h4>
            </div>
          </div>
        }
      />
    </div>
  );
};

NewBusinessAnalysisTableHeader.propTypes = {
  title: PropTypes.string
};

export default NewBusinessAnalysisTableHeader;
